import React, { useEffect, useState } from "react";
import { Button, Icon, message, Modal } from "antd";
import style from "./index.module.scss";
import TopicTypeAddModal from "../TopicTypeAddModal";
import useModalHandler from "utils/useModalHandler";
import TopicTypeListItem from "./components/TopicTypeListItem";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import arrayMove from "array-move";
import useRequest from "utils/useRequest";
import {
    getAddTopicTypeList,
    managerTopicTypeSort,
    saveTopicType,
    TopicItem
} from "service/exercise";
import { ResultMessage } from "components/ResultMessage";
import { errorMessage } from "service/service";
import {
    useTopicTypes,
    useUpdateTypes
} from "service/stores/Exercise/ExerciseTypes";

interface TopicTypeModalProps {
    visible: boolean;
    onCancel: () => void;
    onOk: () => void;
}

export default function TopicTypeModal({
    visible,
    onCancel,
    onOk
}: TopicTypeModalProps) {
    const data = useTopicTypes();
    const reload = useUpdateTypes();
    const [typeList, { loading: typeListLoading }] = useRequest(() =>
        getAddTopicTypeList()
    );

    const [types, setTypes] = useState<TopicItem[]>([]);
    const updateTopicTypes = useUpdateTypes();

    useEffect(() => {
        if (!data) return;
        setTypes(data);
    }, [data]);

    const modal = useModalHandler();

    const SortableList = SortableContainer(
        ({ list }: { list: TopicItem[] }) => {
            return (
                <div>
                    {list.map((value, index) => (
                        <SortableItem
                            key={`item-${value.id}`}
                            index={index}
                            id={value.id}
                            description={value.description}
                            shareStatus={value.shareStatus}
                        />
                    ))}
                </div>
            );
        }
    );

    const SortableItem = SortableElement(
        ({ id, description, shareStatus }: TopicItem) => {
            return (
                <TopicTypeListItem
                    id={id}
                    descript={description}
                    shareStatus={shareStatus}
                    typeList={typeList || []}
                    topicTypOk={topicTypeAddOk}
                />
            );
        }
    );

    const handleSortType = ({
        oldIndex,
        newIndex
    }: {
        oldIndex: number;
        newIndex: number;
    }) => {
        const array = arrayMove(types, oldIndex, newIndex);
        setTypes(array);
        sort(array);
    };

    //题型添加/修改点击ok回调
    async function topicTypeAddOk(
        id: string,
        description: string,
        basicTypeIds: string
    ) {
        try {
            await saveTopicType(id, description, basicTypeIds);

            ResultMessage.success(id ? "修改成功!" : "添加成功！");
            modal.close();
            reload();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    async function sort(typeLs: TopicItem[]) {
        //排序保存
        let array = [];
        let str = "";
        array = typeLs.map(item => {
            return item.id;
        });
        str = array.join(",");

        await managerTopicTypeSort(str);
    }

    //管理题型弹窗确认
    async function addTypeOk() {
        try {
            ResultMessage.success("保存成功！");
            reload();
            onOk();
            updateTopicTypes();
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    return (
        <Modal
            title="管理题型"
            visible={visible && !modal.visible}
            onCancel={onCancel}
            className={style.root}
            onOk={addTypeOk}
            centered
            okText="确认">
            <Button
                block
                className={style.btnAdd}
                type="primary"
                ghost
                onClick={modal.open}>
                <Icon type="file-add" /> 添加题型
            </Button>

            <div className={style.list}>
                {data && (
                    <SortableList
                        list={types}
                        onSortEnd={handleSortType}
                        useDragHandle
                        lockAxis="y"
                    />
                )}
            </div>

            <TopicTypeAddModal
                visible={modal.visible}
                typeList={typeList || []}
                onOk={topicTypeAddOk}
                onCancel={modal.close}
            />
        </Modal>
    );
}
